import store from 'app/store';

export default (Resource, entity, ...rest) =>
  store.dispatch(Resource.update(entity.id, entity, ...rest));
